import { useEffect, useRef, useContext } from 'react';

import { GlobalContext } from "../../contexts/globalContext";

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModeratorVideoComponent = () => {

    const videoRef = useRef(null);
    const { currentModeratorStream, currentConference, currentParticipant } = useContext(GlobalContext)

    useEffect(() => {
        if (currentModeratorStream.videoStream) {
            videoRef.current.srcObject = currentModeratorStream.videoStream;
        } else {
            videoRef.current.srcObject = currentModeratorStream.stream;
        }

    }, [currentModeratorStream])

    return (
        <div style={{ position: "relative", padding: "0px", marginBottom: "5px", borderRadius: "10px", overflow: "hidden", display: "flex", flexDirection: "column" }}>

            <video ref={videoRef} style={{ margin: "0px", padding: "0px" }} width="100%" height="auto" autoPlay muted ></video>

            {currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id &&
                <div style={{
                    position: "relative", width: "900px", height: "250px", background: "#171132", borderRadius: "0px  0px 10px 10px", marginTop: "-5px",
                    justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column"
                }}>
                    <div style={{ font: "normal normal 600 50px/73px Bio Sans", color: `white` }}>{currentModeratorStream.participant.name}</div>
                    <div style={{ font: "normal normal normal 28px/42px Bio Sans", color: "#726FA8" }}>{currentModeratorStream.participant.entitle}</div>

                    <div style={{
                        display: "flex", justifyContent: "center", alignItems: "center", background: "#0B0425", width: "160px", height: "160px", position: "absolute",
                        top: "-100px", borderRadius: "50%"
                    }}>
                        <FontAwesomeIcon style={{ fontSize: "80px", color: "#B2AAC7" }} icon={byPrefixAndName.fas['microphone-stand']} />
                    </div>
                </div>
            }
        </div>
    );
}

export default ModeratorVideoComponent;